import { useNavigate } from "react-router-dom";
import Review from "../components/Review.js";
import { useAppState } from "../state/AppStateContext.js";

export default function ReviewPage() {
  const nav = useNavigate();
  const { addressId, address, selection } = useAppState();

  const getRedirectUrl = (partNumber) => {
    const pn = (partNumber || "").toUpperCase().trim();

    if (pn.startsWith("SD"))   return "https://www.costco.ca/.product.1996435.html";
    if (pn.startsWith("SPN"))  return "https://www.costco.ca/.product.1993065.html";
    if (pn.startsWith("SX"))   return "https://www.costco.ca/.product.1996502.html";
    if (pn.startsWith("STF"))  return "https://www.costco.ca/.product.1988472.html";
    if (pn.startsWith("HTF"))  return "https://www.costco.ca/.product.1988488.html";
    if (pn.startsWith("UHFF")) return "https://www.costco.ca/.product.1988521.html";

    // Fallback if no prefix matches
    return "https://www.costco.ca";
  };

  return (
    <Review
      addressId={addressId}
      address={address}
      selection={selection}
      backToVehicle={() => nav("/vehicle")}
      onRedirect={() => {
        window.location.href = getRedirectUrl(selection?.PartNumber);
      }}
    />
  );
}
